import { nxtKeycloak } from '@future-harry/nxt-keycloak';
import { KeycloakConfig, KeycloakInitOptions } from 'keycloak-js';
import { App, Plugin } from 'vue';

const keycloakConfig: KeycloakConfig = {
   url: import.meta.env.VITE_APP_KEYCLOAK_URL,
   realm: import.meta.env.VITE_APP_KEYCLOAK_REALM,
   clientId: import.meta.env.VITE_APP_KEYCLOAK_CLIENT_ID,
};

const keycloakInitOptions: KeycloakInitOptions = {
   onLoad: 'check-sso',
   responseMode: 'query',
   silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
   checkLoginIframe: import.meta.env.VITE_APP_ENV !== 'dev',
};

const install: Exclude<Plugin['install'], undefined> = function installKeycloak(app: App) {
   app.use(nxtKeycloak, { initOptions: keycloakInitOptions, config: keycloakConfig });
};

export default install;
